module.exports = __webpack_public_path__ + "img/why2.23349d95.svg";